// extracted by mini-css-extract-plugin
export default {"MobileAppButton":"MobileAppButton_MobileAppButton__1j2Cu"};